import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "revico-community-talk-reply-post--contents-error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["CustomLabel"], {
      class: "revico-community-talk-reply-post--contents--label",
      text: "内容(必須)",
      disabled: $props.disabled
    }, null, 8 /* PROPS */, ["disabled"]),
    _createVNode($setup["CustomTextarea"], {
      modelValue: $setup.contents,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ($setup.contents = $event)),
        _cache[1] || (_cache[1] = ($event: any) => ($setup.onChange()))
      ],
      name: "reply.Contents",
      customClass: "revico-community-talk-reply-post--contents",
      "api-validation-error-view-model": $props.apiValidationErrorViewModel,
      maxlength: 10000,
      disabled: $props.disabled,
      placeholder: "返信をお書きください",
      rows: 5,
      "show-required-error": $props.showRequiredError,
      label: "内容"
    }, null, 8 /* PROPS */, ["modelValue", "api-validation-error-view-model", "disabled", "show-required-error"]),
    ($setup.isOverContentsMaxLength)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($setup.replyContentsMaxLength) + "文字以下で投稿してください。", 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}